import { OnCompleteAction } from '../../enums/file-reader/on-complete-action';
import { UniqueSettingsConfig } from '../unique-history/unique-settings-config';

/**
 * Base configuration shared by all file reader types (CSV, XML, JSON).
 * Controls how many files to read, duplicate detection, and post-read file actions.
 */
export abstract class FileReaderBase {
	/** Maximum number of files to read per execution. @default 10 */
	fileReadLimit = 10;
	/** Duplicate file detection settings. */
	uniqueness: UniqueSettingsConfig = new UniqueSettingsConfig();
	/** Action to take on the remote file after a successful read. Nothing=0, Delete=1, Move=2. @default OnCompleteAction.Nothing */
	onSuccessAction = OnCompleteAction.Nothing;
	/** Destination path when onSuccessAction=Move. @default '' */
	onSuccessMovePath = '';
	/** Action to take on the remote file after a failed read. Nothing=0, Delete=1, Move=2. @default OnCompleteAction.Nothing */
	onFailureAction = OnCompleteAction.Nothing;
	/** Destination path when onFailureAction=Move. @default '' */
	onFailureMovePath = '';

	constructor(init?: Partial<FileReaderBase>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
